import React, { useState } from 'react';
import { type Attribute } from '@/common/types/attribute.type';
import { Collapse, Divider } from 'antd';
import Button from '@/common/components/button';
import ArrowDown from '~/public/assets/images/svg/arrow-down.svg';

interface FeatureItem {
  id: number;
  title: string;
  value: string[];
}

interface ProductAttributesCollapseSectionProps {
  data: Attribute[];
}
export const ProductAttributesCollapseSection = ({
  data,
}: ProductAttributesCollapseSectionProps) => {
  const [open, setOpen] = useState(false);

  const items: FeatureItem[] = data.map((attribute) => ({
    id: attribute.attributeId,
    title: attribute.attributeName,
    value: attribute.values.map((item) => item.value),
  }));

  const firstItems = items.slice(0, 4);
  const restItems = items.slice(4);
  const hasMore = restItems.length > 0;

  const renderItem = (
    item: FeatureItem,
    index: number,
    arr: FeatureItem[],
    lastDivider?: boolean
  ): JSX.Element => (
    <div key={item.id}>
      <h4 className="font-medium text-black-default">{item.title}:</h4>

      <div className="flex mt-[6px] flex-wrap">
        <span className="text-sm text-black-400">{item.value.join('، ')}</span>
      </div>

      {(arr.length - 1 !== index || (lastDivider && hasMore)) && (
        <Divider className="!my-3 bg-gray-30" />
      )}
    </div>
  );

  return (
    <div
      id="product-attributes-collapse-section"
      className="bg-white py-4 px-5 rounded-[20px] relative mt-7 scroll-mt-6 text-sm"
    >
      <h3 className="font-semibold text-secondary-400 mb-3">مشخصات</h3>
      {firstItems.map((item, i) => renderItem(item, i, firstItems, true))}
      {hasMore ? (
        <Collapse
          activeKey={open ? ['more'] : []}
          ghost
          bordered={false}
          items={[
            {
              key: 'more',
              label: null,
              showArrow: false,
              className: 'custom-collapse',
              children: restItems.map((item, i) =>
                renderItem(item, i, restItems)
              ),
            },
          ]}
        />
      ) : null}
      {hasMore && !open && (
        <div className="pointer-events-none absolute bottom-14 left-0 right-0 h-[100px] bg-gradient-to-t from-white to-transparent" />
      )}
      {hasMore ? (
        <div className="flex justify-center mt-2">
          <Button
            type="link"
            onClick={() => {
              setOpen(!open);
            }}
            className="flex items-center gap-1 w-fit ml-auto !z-0"
          >
            {open ? 'نمایش کمتر' : 'نمایش بیشتر'}

            <ArrowDown
              className={`transition-transform duration-200 ${
                open ? 'rotate-180' : ''
              }`}
            />
          </Button>
        </div>
      ) : null}
    </div>
  );
};
